import React from "react";
import ItemList from "../components/ItemList";

function MenusKebab() {
  const MENU_INCLUDES = "Patatas fritas + 1 bebida";
  const INCLUDED = "Lechuga, tomate y cebolla";
  const SAUCES = "Salsas a elegir";

  const menusList1 = [
    { key: "kebab", name: "Kebab", meat: "Ternera", menuPrice: "8,00€", price: "4,50€" },
    { key: "shawarma", name: "Shawarma", meat: "Pollo", menuPrice: "8,00€", price: "4,50€" },
    { key: "mixto", name: "Mixto", meat: "Pollo y ternera", menuPrice: "8,00€", price: "5,00€" },
    { key: "durum", name: "Durum", meat: "Pollo o ternera", menuPrice: "9,00€", price: "6,00€" },
    { key: "pizza-turca", name: "Pizza Turca", meat: "Pollo o ternera", menuPrice: "10,00€", price: "7,00€" },
  ].map(item => ({
    ...item,
    description: `${item.meat}. Incluye ${INCLUDED}. ${SAUCES}.`,
    menuIncludes: MENU_INCLUDES
  }));
  return (
    <div id="kebab" className="menu-section">
      <div className="container mx-auto mt-8 px-6">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Menús</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {menusList1.map((menu) => (
            <ItemList
              key={menu.key}
              name={menu.name}
              description={menu.description}
              // OJO: aquí es SOLO menú
              menuPrice={menu.menuPrice}
              menuIncludes={MENU_INCLUDES}
              // si tu ItemList exige price, pásalo vacío
              price={menu.price}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default MenusKebab;